/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import Config from '@config/Config';

import InvalidCredentialsError from '../errors/InvalidCredentialsError';

export default async function GetOTDSTicketByUsernamePassword(username, password) {
  const authData = {
    userName: username,
    password
  };

  // Wrapped in a promise only because we need to wrap the jQuery promise.
  // Do not follow this example in other services.
  return new Promise((resolve, reject) => {
    $.ajax({
      url: Config.getOTDSRESTAuthEndpoint(),
      data: JSON.stringify(authData),
      crossDomain: true,
      contentType: 'application/json',
      dataType: 'json',
      method: 'POST'
    })
      .done((result) => {
        const otdsAuthInfo = {
          resourceId: result.resourceID,
          ticket: result.ticket,
          token: result.token,
          userId: result.userId,
          failureReason: result.failureReason,
          error: result.error
        };
        if (_.isUndefined(result.error)) {
          resolve(otdsAuthInfo);
        } else {
          reject(otdsAuthInfo);
        }
      })
      .fail((err) => {
        if (err.status === 401) {
          reject(new InvalidCredentialsError());
        }
        reject(err);
      });
  });
}
